import { isDev } from "@workwave-tidal/core/base";
import { useEffect } from "react";
const emptyObject = {};
const __DEV__ = isDev();
function useFormVerboseMode(formApi, _updateMode, _name, _fields, _config = emptyObject, verbose) {
  useEffect(() => {
    if (verbose && !__DEV__) {
      console.warn(`You are setting Form Verbose Mode in a non-Production environment. Consider disabling it.`);
    }
    formApi.setDebugMode(verbose ? "verbose" : "silent");
  }, [formApi, verbose]);
}
export {
  useFormVerboseMode
};
//# sourceMappingURL=useFormVerboseMode.js.map
